import { getSupportChannelOptions } from '@/tools';

/**
 * 获取枚举值管理配置
 * @returns {Object}
 */
export function getEnumManageConfig() {
  return {
    channel_interface_options: getSupportChannelOptions(),
  };
}
